import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';

@Module({ dynamic: true, store, name: 'accepterUserRegistration', namespaced: true })
class AccepterUserRegistration extends VuexModule {
  /**
   * @state
   * フォームデータ
   */
  formData: any = [];

  /**
   * @Getter
   * フォームデータ取得
   * @returns formData
   */
  get GET_FORM() {
    return this.formData;
  }

  /**
   * @Action
   * フォームデータ格納
   * @param formData
   */
  @Action({})
  public setFormData(param: any) {
    this.SET_FORM_DATA(param);
  }

  @Action({})
  public moduleReset() {
    this.MODULE_RESET();
  }

  @Mutation
  private SET_FORM_DATA(param: any) {
    this.formData = param;
  }

  @Mutation
  private MODULE_RESET() {
    this.formData = [];
  }

}

export const accepterUserRegistrationModule = getModule(AccepterUserRegistration);
